export default __webpack_public_path__ + "static/media/4_Rechtliche_Moglichkeiten_auf_Landesebene_Kurzversion.9190f84d.pdf";